export const update_type = {
  urgent: {
    label: `Need Urgent Attention!`,
    color: '#d37171',
    icon: 'icon-emergency',
    reaction: 'icon-support',
    filled: 'icon-supportfilled'
  },
  great: {
    label: `I've got great news!`,
    color: '#ffbc00',
    icon: 'icon-thumbsup',
    reaction: 'icon-heart',
    filled: 'icon-heartfilled'
  },
  quick: {
    label: `Here's a quick update`,
    color: '#576da8',
    icon: 'icon-instant',
    reaction: 'icon-thumbsup',
    filled: 'icon-thumbsupfilled'
  },
  sad: {
    label: `I'm sad to inform you...`,
    color: '#a2724f',
    icon: 'icon-sad',
    reaction: 'icon-sad',
    filled: 'icon-sadfilled'
  },
  success: {
    label: `YOU made it happen!`,
    color: '#0fd3cd',
    icon: 'icon-balloons',
    reaction: 'icon-claps',
    filled: 'icon-clapsfilled'
  }
};
